import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=63f968d0&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"
import style0 from "./Program.vue?vue&type=style&index=0&id=63f968d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f968d0",
  null
  
)

export default component.exports